export const environment = {
  production: process.env.NG_APP_ENV === 'production' || process.env.NODE_ENV === 'production',
  hostServerBackOffice: process.env.NG_APP_BACKOFFICE_URL || 'http://127.0.0.1:7070',
  hostServerSecurity: process.env.NG_APP_SECURITY_URL || 'http://localhost:8081'
};